import { API_RESPONSE_STATUS_CODE } from '@app/constants/common';
import { doGet, doPost } from '@app/api';

export const fetchQrcodeFeedbacks = async (clinicId: number, limit: number, offset: number) => {
  try {
    const result = await doGet(`/api/qrcode/feedbacks`, {
      params: { clinicId, limit, offset },
    });
    if (result.status === API_RESPONSE_STATUS_CODE.SUCCESS) {
      return result.data;
    }
  } catch (e) {
    console.log('e', e);
  }
};

export const updateQrcodeFeedback = async (feedbackId: number, isFeedbackReceived: boolean) => {
  try {
    const result = await doPost(`/api/qrcode/feedbacks/${feedbackId}`, {
      isFeedbackReceived,
    });
    if (result.status === API_RESPONSE_STATUS_CODE.CREATED) {
      return result.data;
    }
  } catch (e) {
    console.log('e', e);
  }
};
